module.exports = __webpack_public_path__ + "static/media/elev8.7eac54a1.png";